export default {
  message: {
    'activity_windows':'弹窗活动',
    hello: 'good good study, day day up!',
    确认: 'confirm',
    取消: 'cancel',
    账号激活: 'Account activation',
    输入您的姓名: 'Enter your name',
    请输入密码: 'Please input your password',
    再次确认密码: 'input your password again',
    请选择性别: 'Please select your gender',
    保密: 'secret',
    男: 'man',
    女: 'woman',
    验证长度: 'length is between {0} characters',
    两次输入密码不一致: ' Twice passwords are inconsistent',
    登录: 'Login',
    邮箱: 'email',
    验证码: 'checkCode',
    密码: 'password',
    TR小程序管理系统: 'TR applet manage system ™',
    TR: 'TR applet manage system ™',
    查看帮助文档: 'help',
    修改个人信息: 'personal information',
    登出: 'logout',
    折叠: 'collapse',
    展开: 'expand',
    首页: 'homepage',
    小美首页管理: 'homepage manage',
    小美福利管理: 'welfare manage',
    产品: 'products',
    产品热搜榜管理: 'Product toplist manage',
    产品分类管理: 'Product classify manage',
    产品管理: 'Product manage',
    品牌: 'brand',
    品牌详情类型管理: 'Brand detailtype manage',
    品牌管理: 'Brand manage',
    运营工具: 'Operational tools',
    标签管理: 'Label manage',
    标签清洗: 'Label cleaning',
    第三方平台授权: 'platform authorization',
    组织架构: 'framework',
    组织管理: 'Organization manage',
    员工管理: 'Employee manage',
    欢迎来到: 'welcome to @:message.TR',
    收录各品牌产品总量: 'Total products of all brands included',
    产品总量: 'Total products',
    收录各类型产品总量: 'Include the total amount of various types of products',
    注册用户总量: 'Total registered users',
    用户总量: 'Total users',
    编辑: 'edit',
    刷新: 'refresh',
    保存: 'save',
    轮播图管理: '1.Carousel map management',
    新增: 'add',
    筛选: 'filter',
    输入关键字: 'filter search',
    操作: 'operation',
    轮播图片: 'Carousel map(750*356)',
    无: 'no picture',
    跳转链接: 'url',
    排序: 'sort',
    是否列表显示: 'List display',
    删除确认: 'Delete confirmation',
    请确认是否删除该内容: 'Please confirm whether to delete this content',
    删除: 'delete',
    返回: 'return',
    确定: 'confirm',
    图片: 'picture',
    请输入链接: 'enter url',
    是否显示: 'is show?',
    是: 'yes',
    否: 'no',
    优先级排序: 'sort by priority,small number bigger than the big',
    图片资源库: 'Picture resource library',
    请输入搜索内容: 'Please enter the search content',
    根目录: 'root',
    搜索结果: 'search result',
    上传: 'upload',
    创建文件夹: 'create floder',
    重命名: 'rename',
    移动: 'move',
    图片预览: 'picture review',
    拼命加载中: 'loading...',
    请入文件夹名称: 'enter folder name',
    创建: 'create',
    点击删除将文件移入回收站: 'click delete,move file into recycle bin',
    选择目标文件夹: 'select folder',
    个项目: 'item',
    创建日期: 'create date:',
    关闭: 'close',
    选择: 'select',
    您还未选择任何图片: 'please select anyone picture',
    每次最多上传100个文件: 'most upload count 100',
    上传图片格式: 'Only JPG,PNG,GIF can upload',
    上传图片大小: 'Maxsize 20MB',
    您还未选择任何项目: 'please select anyone item',
    文件夹: 'folder',
    图片尺寸: 'picture size',
    未找到图片或目录: 'cannot found pic or index',
    您还未选择目标路径: 'please select route',
    容量: 'size :',
    小美福利信息管理: 'welfare manage',
    关于小美: '1. about xiaomei',
    顶部图片: 'picture on top',
    头像: 'head portrait',
    昵称: 'nickname',
    输入50个以内文字: 'max input 50 chars',
    内容: 'content',
    请输入内容: 'enter content',
    宠粉福利: '2.fans wefare',
    新建: 'add',
    请选择: 'please select',
    产品ID: 'product ID',
    产品名称: 'product name',
    品牌名称: 'brand name',
    产品图片: 'product picture',
    产品状态: 'product state',
    搜索次数: 'search count',
    浏览次数: 'view count',
    增加搜索次数: 'add searchcount',
    热搜状态: 'topsearch state',
    箭头状态: 'arrow state',
    请确认是否删除该热搜内容: 'confirm delete this item',
    导出: 'output',
    请确认是否导出: 'Is output?',
    产品热搜榜内容编辑: 'Product toplist content edit',
    修改: 'edit',
    产品信息: '1.product message',
    选择产品: 'select product',
    产品描述: 'product detail',
    热搜信息编辑: '2.top search message edit',
    普通: 'normal',
    火热: 'hot',
    新品: 'new',
    上升: 'up',
    下降: 'down',
    增加搜索量: 'add search count',
    创建人: 'author',
    更新日期: 'update date',
    更新人: 'updator',
    产品不能为空: 'last choose anyone product',
    产品列表: 'product list',
    类型: 'type',
    分类ID: 'classifyID',
    分类名称: 'classify name',
    LOGO图片: 'logo',
    父分类ID: 'pre classifyID',
    继承分类ID: 'next classifyID',
    请确认是否删除该分类: 'confirm delte this classify',
    父菜单容器型: 'Parent menu container',
    商品列表型: 'Commodity list type',
    品牌型: 'brand type',
    数据结构型: 'Data structure type',
    产品分类编辑: 'classify edit',
    分类主信息: '1.main infomation of classify',
    输入10个以内汉字: 'maxlength 20 chars',
    是否临时分类: 'is tempdent classify',
    分类轮播图: '2.Classify Rotation chart',
    添加: 'add',
    分类下的产品管理: '3.Classify product management',
    轮播图管理sel: 'Carousel map management',
    名称不能为空: 'name is required',
    确认关闭: 'closing ?',
    未定义: 'undefined',
    正常: 'normal',
    已下架: 'Removed',
    不显示: 'not display',
    请确认是否删除该产品: 'is delete this product?',
    产品详情编辑: 'product detail edit',
    产品主信息: '1.product message',
    请输入产品名称: 'enter product name',
    产品主图: 'product main picture',
    请输入产品描述: 'enter product describe',
    产品轮播图: '2.product Carousel map',
    详情类型ID: 'Detail type ID',
    详情类型名称: 'Detail type name',
    品牌详情类型编辑: 'Brand detail type edit',
    详情类型名称不能为空: 'detail type name is required',
    品牌ID: 'brandID',
    品牌描述: 'Brand describe',
    品牌图片: 'Brand picture(700*760)',
    是否外链: 'is outlink?',
    请确认是否删除该品牌: 'is delete the brand',
    品牌编辑: 'brand edit',
    品牌主信息: '1.Brand main message',
    输入20个以内汉字: 'maxlength 40 chars',
    品牌图片: 'Brand picture',
    是否为外链: 'is outlink?',
    品牌详情管理: '2.Brand detail management',
    品牌详情ID: 'Brand detailID',
    品牌详情类型: 'Brand detail type',
    标题: 'title',
    主图片: 'main picture(750px)',
    内容1: 'content 1',
    中间图片: 'middle picture(750px)',
    内容2: 'content 2',
    品牌详情编辑: 'Brand detail edit',
    详情类型: 'detail type',
    主图片sel: 'main picture',
    中间图片sel: 'middle picture',
    输入关键字搜索: 'keyword search',
    标签ID: 'tagID',
    标签名称: 'tag name',
    标签下的用户数: 'user count of tag',
    创建标签: 'create tag',
    请输入标签名称: 'enter tag name',
    编辑标签: 'tag edit',
    请确认是否删除该标签: 'is delete the tag',
    导出用户数据耗时较长请确认是否导出: 'export user data will much cost time',
    正在导出用户数据: 'exporting user data',
    当前状态: 'state:',
    下载: 'download',
    该主体的标签数量已达上限: 'tag nums is arrive 100,cannot creat tag',
    选择标签: 'select tags',
    上传用户: 'uplaod user',
    提交标签: 'submit tag',
    选择需处理的标签: 'Step 1. select tag',
    清空: 'clear',
    提交: 'submit',
    进行CSV字段名称转换: 'csv item name transform:',
    开启: 'open',
    CSV对应字段名称: 'csv item name',
    设置反向标签: 'set reverse oriention tag: ',
    请选择标签ID: 'select tagID',
    错误与待处理标签有重复: 'error:Error duplicate with pending tag',
    上传用户数据CSV文件: 'Step 2. upload user data by csv',
    将文件拖到此处: 'Drag files here',
    点击上传: 'click here for upload',
    只能上传文件: 'file only .csv or .zip',
    下载报告: 'download report',
    提交数据至微信: 'Step 3. submit data to wechat',
    提交标签需要较长时间完成: '※ submit tag need time,patience donnot refresh',
    编辑转换名称: 'edit transform name',
    请输入标签转换名称: 'enter after name',
    正在上传用户数据: 'uploading',
    导入结果报告: 'Import results report',
    数量: 'counts',
    正在对标签进行清洗: 'clearing the tag ',
    清洗结果报告: 'clear results report',
    每次最多上传1个文件: 'cannot upload much than 1',
    已确认无误并提交标签吗: 'confirm no mistake and submit tag',
    确认取消: 'cancel?',
    您的编辑还未保存是否离开: 'leave with not save?',
    标签列表: 'tags list',
    正在授权: 'Authorizing....',
    第三方平台授权: 'Third party platform authorization',
    前往授权: 'Go to authorization',
    授权成功: 'Authorization succeeded',
    暂无数据: 'no data',
    组织: 'Organization',
    部门: 'department',
    岗位: 'post',
    员工: 'employee',
    名称: 'name:',
    请输入组织名称: 'Organization name',
    状态: 'state:',
    禁用: 'disabled',
    备注: 'remark:',
    请输入备注内容: 'enter remark',
    组织信息: 'Organization info',
    组织名称不能为空: 'Organization name is required',
    添加组织: 'add Organization',
    创建者: 'author:',
    创建时间: 'create time:',
    编辑者: 'editor:',
    编辑时间: 'edit time:',
    父级对象: 'pre object:',
    父级类型: 'pre type',
    部门信息: 'department info',
    部门名称不能为空: 'department name is required',
    总部: 'headquarters',
    请选择父级对象: 'please choose pre object',
    添加部门: 'add department',
    所属部门: 'Department:',
    权限信息: 'permissions information',
    权限设置: 'permissions set:',
    全选: 'all',
    员工信息: 'employee info',
    添加员工: 'add employee',
    工作名: 'workname',
    移除: 'remove',
    联系方式: 'contact',
    岗位名称不能为空: 'job name is required',
    请选择所属部门: 'please choose Department',
    岗位信息: 'job info',
    添加岗位: 'add job',
    未激活: 'not active',
    被冰冻: 'Frozen',
    员工状态: 'employee state',
    姓名: 'name',
    手机: 'mobile',
    性别: 'gender',
    工作名称: 'workname',
    部门ID: 'departmentID',
    部门名称: 'department name',
    岗位ID: 'jobID',
    岗位名称: 'job name',
    工作名称不能为空: 'workname cannot empty',
    员工名称不能为空: 'employee name cannot empty',
    请输入搜索员工手机号: 'enter search telphone',
    请输入搜索手机号: 'enter search telphone',
    权限: 'permissions',
    外部用户: 'normal user',
    客服: 'customer service',
    经理: 'manager',
    超级管理员: 'Super administrator',
    手机号码: 'phonenumber',
    照片: 'picture',
    员工列表: 'employee list',
    当前搜索手机号不存在点击确认添加: 'The current search mobile number does not exist. Click OK to add',
    注册用户: 'registered users',
    账号验证: 'Account check',
    个人信息: 'personal information',
    验证码和确认提交: 'check code and confirmation submission',
    完成: 'complete',
    账号: 'Account',
    电话: 'telphone',
    请选择地区: 'choose area',
    请输入电话号码: 'enter telphone',
    获取验证码: 'get check code',
    秒后再次获取验证码: 'seconds Obtain the check code again',
    注册账号成功: 'Account registration succeeded',
    登录账号: 'Login account',
    默认密码: 'Default password',
    退出: 'return',
    上一步: 'Previous',
    下一步: 'Next',
    再次注册: 'Register again',
    确认注册: 'Confirm registration',
    请输入名字: 'please enter name',
    请输入有效的电话号码: 'Please enter a valid phone number',
    请输入验证码: 'Please enter the check code',
    请输入账号名: 'Please enter the account name',
    账号名长度: 'The account name is 3-36 in length, can contain numbers, letters and underscores, and is not registered',
    用户中心: 'userCenter',
    设置: 'setting',
    选择头像: 'choose avator',
    确认修改: 'update',
    重置: 'reset',
    修改注册电话: 'register phone edit',
    修改账号密码: 'change password',
    原密码: 'old password',
    新密码: 'new password',
    再次输入: 'again',
    请输入旧密码: 'enter old password',
    请输入新密码: 'enter new password',
    请再次输入新密码: 'input new password again',
    两次输入的新密码不一致: 'twice input is required equaty',
    注册电话: 'register telphone',
    修改密码: 'change password',
    上传头像图片格式只能为: 'picture only has extraname png/jpg/jpeg can pass',
    图片大小不能超过2mb: 'picture size maxmium 2mb',
    账号密码: 'account and password',
    企业设置: 'enterpriseSettings',
    test: 'test',
    开放平台: 'open plat',
    接口比例: 'Available APIs/APIs',
    API调取统计: 'API statistics',
    每秒可调用接口次数: 'Tunable APIs per second',
    重置时间: 'Reset time',
    API认证信息: 'API authentication',
    查看API文档: 'View API doc',
    查看API说明: 'View API description',
    白名单: 'Whitelist',
    添加IP或域名: 'ADD IP OR Domain',
    显示: 'show',
    隐藏: 'hidden',
    重置accessKeySecret: 'reset accessKeySecret',
    安全提示: 'Security Tip: Please keep API authentication information properly, and remember not to give accessKeySecret to untrusted third parties. Avoid taking screenshots of this page.',
    权限提示: 'Since the sub-account is affected by the data permissions, the data retrieved through the access-key of the sub-account will be controlled by the data permissions',
    ip域名备注: 'Note: Add at least one IP or domain, otherwise the API will report an error.',
    ip域名提示: 'The domain name does not need to add http:// or https://',
    最多可以创建5个服务器IP或域名: 'Up to 5 server IPs or domains can be created.',
    域名: 'domain',
    删除提醒: 'delete remark',
    好的: 'OK',
    可用接口: 'Available APIs',
    划线的为不可用接口若要使用请联系客户经理: 'The underlined APIs is not available. Please contact the account manager if you want to use it',
    模块: 'Module',
    接口: 'APIs',
    速流限制: 'Flow speed limit',
    已调取次数: 'Used/Remaining',
    天: 'days',
    最大调取: 'Maximum',
    次: 'freq',
    元数据: 'raw data',
    属性名: 'data name',
    字段含义: 'data desc',
    mongo字段名: 'mongo name',
    fieldid: 'fieldid',
    字段类型: 'data type',
    数据来源: 'data source',
    预制状态: 'pre status',
    父字段名称: 'parentType name',
    长度: 'length',
    聚合字段: 'Aggregate field',
    显示标记: 'show marks',
    主键标记数字越大优先级越高: 'Primary key tag',
    验证手机号: 'has phoneNumber resgister',
    验证注册信息: 'has resgisted',
    会员中心: 'vip center',
    会员管理: 'vip management',
    角色管理: 'role management',
    角色id: 'roleID',
    角色名: 'roleName',
    角色描述: 'roleDesc',
    级别: 'level',
    类别: 'classify',
    降级id: 'is retire',
    降级显示: 'retire show',
    降级名: 'retireName',
    降级描述: 'retireDesc',
    角色管理编辑: 'roleManagementEdit',
    角色主信息: 'roleMainMessage',
    角色logo: 'roleLogo',
    角色信息: 'roleDesc',
    添加角色条件: 'addSelectCondition',
    编辑条件表达式: 'editSelectCondition',
    是否开启降级规则: 'is retire',
    不满足后名字: 'retiredName',
    请输入描述: 'enter Desc',
    不满足后信息: 'retiredDesc',
    不满足条件角色logo: 'retiredShowImg',
    用户id: 'userID',
    用户角色id: 'userRoledId',
    真实名: 'realname',
    注册时间: 'registerTime',
    初次登录时间: 'firstLoginTime',
    国家: 'country',
    省份: 'province',
    城市: 'city',
    未知: 'unkown',
    会员信息详情: 'vipInfoDesc',
    会员信息: 'vipInfo',
    活动记录: 'activityRemark',
    浏览记录: 'browsehistory',
    会员卡: 'vipCard',
    购物车: 'cart',
    优惠券: 'coupons',
    收藏夹: 'favorite',
    推送人: 'marketing',
    订单: 'order',
    积分: 'score',
    活动奖励: 'rewards',
    openid: 'openid',
    unionID: 'unionID',
    shopID: "shopID",
    userKey: 'userKey',
    语言: 'language',
    用户昵称: 'nickName',
    用户名: 'userName',
    用户状态: 'isDemoted',
    customFields: 'customFields',
    生日: 'birthDay',
    标签: 'tag',
    居住城市: 'homewhere',
    平台类型: 'platformType',
    登录ID: 'loginID',
    邀请人ID: 'inviterID',
    邀请方式: 'inviterType',
    最近登录时间: 'lastLoginDate',
    grouping: 'grouping',
    identityCard: 'identityCard',
    identityCardImg: 'identityCardImg',
    自定义主页: 'autosetIndexPage',
    条件表达式: 'groupByCondition',
    分群名称: 'groupName',
    选择分组: 'chosseClass',
    条件蔟: 'groupCondition',
    且: 'And',
    或: 'Or',
    请选择添加的事件类型: 'selectTypeOfCondition',
    点击添加: 'add',
    用户数据: 'userData',
    事件数据: 'conditionData',
    订单数据: 'orderData',
    表单数据: 'sheetData',
    优惠券数据: 'couponsData',
    至: 'to',
    选择日期时间: 'selectDate',
    在: 'in',
    天: 'day',
    等于: '=',
    不等于: '!=',
    大于: '>',
    小于: '<',
    有值: 'notEmpty',
    没值: 'isEmpty',
    区间: 'between',
    真: 'true',
    伪: 'false',
    包含: "in",
    不包含: 'not in',
    属于: "belong",
    不属于: 'notBelong',
    当前时间点: "isTime",
    低代码编辑平台主页: 'autoIndexPageEdit',
    配置选项: 'config',
    整体布局: 'pageConfig',
    单项配置: 'itemConfig',
    侧边栏配置: 'asideBarConfig',
    恢复: 'return',
    文字框编辑区域: 'fontEditConfig',
    用户事件: 'userAction',
    会员状态: 'vipState',
    事件类型: 'eventType',
    微信openID: 'openID',
    页面路径: 'url',
    描述: 'desc',
    source: 'source',
    编辑日期: 'editDate',
    微信unionID: 'unionID',
    外部平台ID: 'outPlatformID',
    地理位置: 'coordination',
    事件内容: 'content',
    数据ID1: "dataID1",
    数据ID2: "dataID2",
    数据ID3: "dataID3",
    数据ID4: "dataID4",
    数据ID5: "dataID5",

    完成度: "完成度",

    日期类型: 'dateType',
    发生时间: "eventDate",
    小美配置项: 'xiaomeiconfig',
    小美配置管理: 'xiaomeiconfigmanage',
    首页弹出框图片: 'indexImg',
    弹出框图片: 'Img',
    关注图片: 'guanzhu',
    会员身份: 'vipstate',
    appID: 'appID',
    全部行为: 'all action',
    点击行为: 'click',
    进入页面: 'go in page',
    离开页面: 'out page',
    点击活动: 'click action',
    点击产品: 'click pro',
    点击底部菜单: 'click footerMenu',
    用户分享: "share",
    点击链接: 'click url',
    搜索: 'search',
    点击banner: 'click banner',
    外部页进入: 'out page in',
    点击关注: 'click guanzhu',

    跳转外部页: '跳转外部页',
    跳转外部小程序: '跳转外部小程序',
    跳转视频号: '跳转视频号',
    文章阅读完成: '文章阅读完成',
    页面访问时长: '页面访问时长',
    资源位点击: '资源位点击',
    用户注册: '用户注册',
    完善信息: '完善信息',
    订阅消息: '订阅消息',
    添加心愿: '添加心愿',
    填写表单: '填写表单',
    点赞: '点赞',

    预约设置: 'appointment',
    基础信息设置: 'Step 1. Information setting',
    参加条件设置: 'Step 2. JOIN condition setting',
    完成条件设置: 'Step 3. Arrive condition setting',
    领取奖励设置: 'Step 4. Get price setting',
    活动设置: 'action setting',
    活动: 'action',
    商品库存: 'count',
    门店管理: 'shop manage',
    活动名称: 'action name',
    活动id: 'actionid',
    自定义url: 'url',
    门店: 'shop',
    活动图片: 'img',
    活动图片1: 'img750*min（500）',
    开始日期: "start date",
    结束日期: 'end date',
    参与次数统计: 'partcipe count',
    完成次数统计: 'acheive count',
    小美页面管理: 'page management',
    跳转类型: "jumptype",
    跳转微信id: 'jump wechatid',
    分类下的子分类管理: 'child classify manage',
    产品说明: "2.product desc",
    参加序列号: 'serialNo',
    预约开始时间: 'appointmentFrom',
    预约结束时间: 'appointmentTo',
    openID: "openID",
    预约序列号: "serialNo",
    同行人数: 'together',
    userID: 'userID',
    选择日期: 'select date',
    门店id: 'shopid',
    门店名: 'shop name',
    是否完成: 'isComplete',
    活动类型: 'showtype',
    奖品库存: 'reward store',
    openAPI接口管理: 'openAPI interface management',
    查阅配表: 'more interface ID information,please check the ModuleApi.xlsm',
    添加接口限制: 'add interface limit',
    接口ID: 'interface ID',
    限制次数: 'request limit times',
    商家名: 'vendorName',
    商家描述: 'vendorDesc',
    添加openApi调用限制: 'add openApi limit',
    积分管理: '积分管理',
    积分分组: '积分分组',
    积分获取: '积分获取',
    积分组管理: '积分组管理',
    分组ID: '分组ID',
    分组名称: '分组名称',
    积分规则说明: '积分规则说明',
    有效期类型: '有效期类型',
    积分组详情编辑: "积分组详情编辑",
    积分组信息: '积分组信息',
    请输入积分规则说明: '请输入积分规则说明',
    有效期类型: '有效期类型',
    请输入有效期参数: '请输入有效期参数',
    有效期参数: '有效期参数',
    获取积分上限: '获取积分上限',
    是否有获取上限: '是否有获取上限',
    积分组编辑: '积分组编辑',
    获取积分通知方式: '获取积分通知方式',
    获取积分消息内容: '获取积分消息内容',
    请输入获取积分消息内容: '请输入获取积分消息内容',
    消费积分通知方式: '消费积分通知方式',
    消费积分消息内容: '消费积分消息内容',
    请输入消费积分消息内容: '请输入消费积分消息内容',
    积分分组名称: '积分分组名称',
    积分分组ID: '积分分组ID',
    积分获取方式管理: '积分获取方式管理',
    积分获取方式: '积分获取方式',
    获取方式ID: '获取方式ID',
    获取积分: '获取积分',
    触发类型: '触发类型',
    需触发次数: '需触发次数',
    限制次数: '限制次数',
    限制类型: '限制类型',
    限制间隔: '限制间隔',
    备注信息: '备注信息',
    积分获取方式编辑: '积分获取方式编辑',
    请确认是否删除该分组: '请确认是否删除该分组',
    请确认是否删除该获取方式: '请确认是否删除该获取方式',
    积分获取方式ID: '积分获取方式ID',
    请输入: '请输入',
    是否有次数限制: '是否有次数限制',
    积分获取记录: '积分获取记录',
    积分消费记录: '积分消费记录',
    用户积分管理: '用户积分管理',
    MGM活动管理: 'MGM活动管理',
    MGM活动编辑: "MGM活动编辑",
    MGM活动ID: 'MGM活动ID',
    请确认是否删除: '请确认是否删除',
    活动海报编辑: '活动海报编辑',
    活动备注: '活动备注',
    背景图片: '背景图片',
    参加条件: '参加条件',
    分享图片生成器编辑: '分享图片生成器编辑',
    激活码大小: '激活码大小',
    激活码位置X轴: '激活码位置X轴',
    激活码位置Y轴: '激活码位置Y轴',
    太阳码大小: '太阳码大小',
    太阳码位置X轴: '太阳码位置X轴',
    太阳码位置Y轴: '太阳码位置Y轴',
    活动ID: '活动ID',
    规则详情: '规则详情',
    订阅消息: '订阅消息',
    MGM活动排行榜: 'MGM活动排行榜',
    MGM活动: 'MGM活动',
    请选择MGM活动: "请选择MGM活动",
    排名: "排名",
    邀请人数: '邀请人数',
    积分排行榜: '积分排行榜',
    请选择积分分组: '请选择积分分组',
    标签分组: '标签分组',
    标签分组ID: '标签分组ID',
    标签分组名称: '标签分组名称',
    标签分组列表: '标签分组列表',
    标签分组详情: '标签分组详情',
    兴趣标签列表: '兴趣标签列表',
    兴趣标签ID: '兴趣标签ID',
    兴趣标签名称: '兴趣标签名称',
    兴趣标签详情: '兴趣标签详情',
    搜索维度: '搜索维度',
    资源位: '资源位',
    场景: '场景',
    推荐搜索关键词管理:'推荐搜索关键词管理',
    分类管理:'分类管理',
    优惠券管理:'coupon management',
    货品管理:'货品管理',
    货架:'货架',
    测试:'test'
  }
}


// WEBPACK FOOTER //
// ./src/language/en.js